import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const UnauthenticatedDialog = ({ open, onCancel, onConfirm, fromEmail }) => {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>Proceed without domain authentication?</DialogTitle>
            <DialogContent>
                <Alert severity="warning" icon={<WarningAmberIcon fontSize="inherit" />}>
                    <Typography variant="body2">
                        Your sending domain has not been authenticated. Emails will currently be sent from <strong>{fromEmail}</strong> to improve inbox delivery.
                    </Typography>
                </Alert>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Are you sure you want to continue?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="primary" autoFocus>
                    Yes, proceed
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UnauthenticatedDialog;
